import { Route, Routes } from 'react-router-dom'

import Bookings from './screens/Bookings/screens/List'
import CancelledItems from './screens/CancelledItems/screens/List'
import Editorials from './screens/Editorials/screens/List'
import Inspections from './screens/Inspections/screens/List'
import Deadlines from './screens/Deadlines/screens/List'
import Preflighting from './screens/Preflighting/screens/List'
import RequirePagination from './screens/RequirePagination/screens/List'

const NewsDeskRoutes = (props: { pageFilters: object }) => {
  const { pageFilters } = props

  return (
    <Routes>
      <Route
        path="/bookings"
        element={<Bookings pageFilters={pageFilters} />}
      />

      <Route
        path="/deadlines"
        element={<Deadlines pageFilters={pageFilters} />}
      />

      <Route
        path="/cancelledItems"
        element={<CancelledItems />}
      />

      <Route
        path="/editorials"
        element={<Editorials pageFilters={pageFilters} />}
      />

      <Route
        path="/inspections"
        element={<Inspections pageFilters={pageFilters} />}
      />

      <Route
        path="/preflighting"
        element={<Preflighting pageFilters={pageFilters} />}
      />

      <Route
        path="/requirePagination"
        element={<RequirePagination pageFilters={pageFilters} />}
      />
    </Routes>
  )
}
export default NewsDeskRoutes
